/**
 * Moves the Fusedeck cookie consent dialog (.fd-consent-main) to appear
 * right after the skip-link nav (#AccesskeyNavigation) so keyboard users
 * encounter it early in the tab order (WCAG 2.1 §2.4.1).
 *
 * The Fusedeck script injects the dialog asynchronously, so we use a
 * MutationObserver to detect it.
 */
export function initCookieDialogA11y() {
  const anchor = document.getElementById('AccesskeyNavigation');
  if (!anchor || !anchor.parentNode) return;

  function relocate(dialog) {
    if (anchor.nextSibling === dialog) return;
    anchor.parentNode.insertBefore(dialog, anchor.nextSibling);
  }

  // Handle dialog already in DOM (e.g. cached page, fast script)
  const existing = document.querySelector('.fd-consent-main');
  if (existing) {
    relocate(existing);
    return;
  }

  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList.contains('fd-consent-main')
        ) {
          relocate(node);
          observer.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true });
}
